/**
 * Created by rhinov15 on 01/08/2016.
 *
 * This code transforms SavaneJS entities and objects into graphical nodes for display through cocos plan
 * maybe should be called node manager...
 */
import { Utils } from "../utils/Utils";
import { WindowNode } from "./EntityNodes/JoineryNodes/WindowNode";
import { DoorNode } from "./EntityNodes/JoineryNodes/DoorNode";
import { TechnicalElementNode } from "./EntityNodes/TechnicalElementNode";
import { NicheNode } from "./EntityNodes/JoineryNodes/NicheNode";
import { OpeningNode } from "./EntityNodes/JoineryNodes/OpeningNode";
import { CameraNode } from "./EntityNodes/CameraNode";
import { GeometryPrimitiveNode } from "./EntityNodes/GeometryPrimitiveNode";
import { PictureNode } from "./EntityNodes/PictureNode";
import { SunNode } from "./EntityNodes/SunNode";
import { FloorNode } from "./EntityNodes/FloorNode";
import { RoomNode } from "./EntityNodes/RoomNode";
import { VeluxNode } from "./EntityNodes/JoineryNodes/VeluxNode";
import { FrontDoorNode } from "./EntityNodes/JoineryNodes/FrontDoorNode";
import { FrenchDoorNode } from "./EntityNodes/JoineryNodes/FrenchDoorNode";
import { CupboardDoorNode } from "./EntityNodes/JoineryNodes/ClosetDoorNode";
import { WallNode } from "./EntityNodes/WallNode";
import { CommentNode } from "./EntityNodes/CommentNode";
import { FixedWindowNode } from "./EntityNodes/JoineryNodes/FixedWindowNode";
import { ArrangementNode } from "./EntityNodes/ArrangementNode";
import { GroupNode } from "./EntityNodes/GroupNode";
import { FrontViewManager } from "./FrontViewManager";
import { StaircaseNode } from "./EntityNodes/StaircaseNode";
import { WorkTopNode } from "./EntityNodes/WorktopNode";
import { CanopyNode } from "./EntityNodes/JoineryNodes/CanopyNode";
import { PictureWindowNode } from "./EntityNodes/JoineryNodes/PictureWindowNode";
import { GameObjectManager } from "./GameObjectManager";
import { EntityNode } from "./EntityNodes/EntityNode";
import { JoineryNode } from "./EntityNodes/JoineryNode";
import { PlanManager } from "../../../cocosPlan";
import { ArrangementGroup, ArrangementObject, Canopy, Comment, CupboardDoor, Door, Entity, Event, Events, eventsManager, FrenchDoor, GeometryGroup, GeometryPrimitive, Joinery, Listener, Niche, Opening, PictureWindow, RenderCamera, Room, SceneConstants, Staircase, Sun, TechnicalElement, UserPicture, Velux, Wall, Window, WorkTop } from "@rhinov/savane-js";


export class EntityManager {

    /* Add and delete entity listener to add/remove entities from the graphical manager from outside */
    addEntityListener: Listener | null = eventsManager.instance.addListener(Events.ADD_GRAPHICAL_ENTITY, (datas: Event) => {
        this.addEntity(datas.getUserData().entity);
    });
    deleteEntityListener: Listener | null = eventsManager.instance.addListener(Events.REMOVE_GRAPHICAL_ENTITY, (datas: Event) => {
        this.removeEntity(datas.getUserData().entity);
    });
    redrawEntityListener: Listener | null = eventsManager.instance.addListener(Events.REDRAW_GRAPHICAL_ENTITY, (datas: Event) => {
        var entity = datas.getUserData().entity;
        var node = this.getNode(entity);
        if (node !== null) {
            switch (entity.entityType) {
                case SceneConstants.EntityType.Room:
                    node.updateTriangles();
                    break;

                case SceneConstants.EntityType.Wall:
                    node.calculateNeighboorWallValues(entity);
                    break;
            }
            node.needRedraw = true;

            var extraActions = datas.getUserData().extraActions;
            if (extraActions) {
                for (var i = 0 ; i < extraActions.length ; i++) {
                    switch(extraActions[i]) {
                        case 'deleteMenu':
                            node.deleteMenu();
                            break;

                        case 'addMenu':
                            node.addMenu();
                            break;

                        case 'updateName':
                            node.updateName();
                            break;
                    }
                }
            }
        }
    });

    unableStrechabilityEntityListener: Listener | null = eventsManager.instance.addListener(Events.UNABLE_STETCHABILITY_ENTITY, (datas: Event) => {
        var entity = datas.getUserData().entity;
        var active = datas.getUserData().active;
        var node = this.getNode(entity);
        if (node !== null) {
            node.addStretchability(active);
            node.updateSprite();
            node.needRedraw = true;
        }
    });

    redrawRoomListener: Listener | null = eventsManager.instance.addListener(Events.REDRAW_GRAPHICAL_ROOM, function(datas: Event) {
        GameObjectManager.drawRoom(datas.getUserData().entity, false, null, true, undefined);
    });
    redrawWallListener: Listener | null = eventsManager.instance.addListener(Events.REDRAW_GRAPHICAL_WALL, function(datas: Event) {
        GameObjectManager.drawWall(datas.getUserData().entity, true, false, undefined, undefined, undefined);
    });
    redrawFrontViewAreaListener: Listener | null = eventsManager.instance.addListener(Events.REDRAW_FRONTVIEW_AREA, function(datas: Event) {
        if (PlanManager.getInstance().frontViewLayer.isVisible()) {
            FrontViewManager.drawArea(datas.getUserData().component, false, undefined, undefined, undefined, undefined);
        }
    });
    deleteFrontViewAreaListener: Listener | null = eventsManager.instance.addListener(Events.DELETE_FRONTVIEW_AREA, function(datas: Event) {
        if (PlanManager.getInstance().frontViewLayer.isVisible()) {
            FrontViewManager.deleteArea(datas.getUserData().component.id);
        }
    });
    createUserMapListener: Listener | null = eventsManager.instance.addListener(Events.CREATE_USER_MAP, function(datas: Event) {
        GameObjectManager.createUserMap(datas.getUserData().component.url, datas.getUserData().component.scale, datas.getUserData().component.userScale, datas.getUserData().component.rotation, datas.getUserData().component.offset);
    });
    deleteUserMapListener: Listener | null = eventsManager.instance.addListener(Events.DELETE_USER_MAP, function(_datas: Event) {
        GameObjectManager.deleteUserMap();
    });

    private constructor() {
    }

    static getInstance() {
        const g = globalThis as any;
        if (!g.__rhinov_EntityManager_instance) {
            g.__rhinov_EntityManager_instance = new EntityManager();
        }
        return g.__rhinov_EntityManager_instance;
    }

    // Adds entity/node to the entity manager
    addEntity(entity: Entity): EntityNode | null {
        // Create the entity node
        var node = this.createNode(entity, undefined);

        // Parse entity's children and create new nodes recursively
        for (var i = 0; entity.children && i < entity.children.length; i++) {
            this.addEntity(entity.children[i]);
        }

        // Return the created node
        return node;
    };
    // Deletes an entity/node from the entity manager
    removeEntity(entity: Entity): boolean {
        this.deleteNodeAndChild(entity);

        return false;
    };

    /**
    * Set draw order depending on entityType
    * (Example: room floor is under all other elements)
    * returns the Z value cocos plan will use to determine the drawing order of sprites
    *
    **/
    getLevel(entity: Entity): number {
        // Default zindex is 100, if > 100 more pririty, < 100 less priority
        var zIndex = 100;

        switch (entity.entityType) {
            case SceneConstants.EntityType.Wall:
                zIndex = 100 + ((entity as Wall).height / 20);
                break;

            // Arrangement objects priority starts at 101 and we add the height of the object / 20 so they can be sorted between them
            case SceneConstants.EntityType.WorkTop:
                zIndex = 101 + (entity.maxHeight! / 20);
                break;

            case SceneConstants.EntityType.ArrangementObject:
            case SceneConstants.EntityType.ArrangementGroup:
                zIndex = 101 + ((entity as ArrangementGroup).minHeight / 20);
            break;

            // technical elements starts at 102 and we find their middle height point / 20 to determine the order
            case SceneConstants.EntityType.TechnicalElement:
            case SceneConstants.EntityType.GeometryPrimitive:
                if (entity.floorHeight !== undefined) {
                    zIndex = 102 + (((entity.floorHeight + (entity as TechnicalElement).height) * 0.5) / 20);
                }
                else {
                    zIndex = 102;
                }
                break;

            case SceneConstants.EntityType.Joinery:
                if (entity.floorHeight !== undefined) {
                    zIndex = 101 + (((entity.floorHeight + (entity as Joinery).height) * 0.5) / 20);
                }
                else {
                    zIndex = 101;
                }

                if (entity.parent && entity.parent instanceof Wall) {
                    zIndex += (entity.parent.height / 20);
                }
                else  {
                    zIndex = 1000000;
                }
                break;

            // Floor is just above a room
            case SceneConstants.EntityType.Floor:
                zIndex = 1;
                break;

            // A room has the smallest priority
            case SceneConstants.EntityType.Room:
                zIndex = 2;
                break;

            // Render camera and light sprites have the highest priority (above everything else)
            case SceneConstants.EntityType.RenderCamera:
            case SceneConstants.EntityType.Comment:
                zIndex = 1000000;
                break;
        }

        var node = this.getNode(entity);

        if (node !== null) {
            if (node._isSelected || node._isHovered) {
                zIndex++;
            }
            if (node.visible === false) {
                return -1;
            }
        }

        return zIndex;
    };

    /**
    * Create entity node
    *
    * @param {Object} entity SavaneJS entity
    * @param {boolean} importChild If set to true will create child node
    **/
    createNode(entity: Entity, importChild?: boolean): EntityNode | null{
        // FIXME Force to true for debug purpose
        var globally = true;
        var layer = PlanManager.getInstance().scrollWindow.grid;
        // Check if the entity already has an existing node
        var oldNode = Utils.getChildByNameRecursivly(layer, entity.id);
        // Will receive the created node to return
        var node = null;

        // If it does, do not create a new node, just return the existing node
        if (oldNode !== null) {
            //console.log("EntityNode " + entity.id + " already exist");
            return oldNode;
        }

        // Create a gra^hic node depending on the entity type
        switch (entity.entityType) {
            case SceneConstants.EntityType.Floor:
                node = new FloorNode(entity);
                break;

            case SceneConstants.EntityType.RenderCamera:
                node = new CameraNode(entity as RenderCamera);
                break;

            case SceneConstants.EntityType.Comment:
                node = new CommentNode(entity as Comment);
                break;

            case SceneConstants.EntityType.GeometryPrimitive:
                node = new GeometryPrimitiveNode(entity as GeometryPrimitive);
                break;

            case SceneConstants.EntityType.UserPicture:
                node = new PictureNode(entity as UserPicture);
                break;

            case SceneConstants.EntityType.Sun:
                node = new SunNode(entity as Sun);
                break;

            case SceneConstants.EntityType.Joinery:
                node = this.createJoinery(entity as Joinery);
                break;

            case SceneConstants.EntityType.Room:
                node = new RoomNode(entity as Room);
                break;

            case SceneConstants.EntityType.Wall:
                node = new WallNode(entity as Wall);
                break;

            case SceneConstants.EntityType.ArrangementObject:
                if (PlanManager.getInstance().frontViewLayer.isVisible()) {
                    FrontViewManager.updateDecoration(entity);
                }
                node = new ArrangementNode(entity as ArrangementObject);
                break;

            case SceneConstants.EntityType.GeometryGroup:
            case SceneConstants.EntityType.ArrangementGroup:
                node = new GroupNode(entity as ArrangementGroup | GeometryGroup);
                break;

            case SceneConstants.EntityType.Staircase:
                node = new StaircaseNode(entity as Staircase);
                break;

            case SceneConstants.EntityType.TechnicalElement:
                node = new TechnicalElementNode(entity as TechnicalElement);
                break;

            case SceneConstants.EntityType.WorkTop:
                node = new WorkTopNode(entity as WorkTop);
                break;

            default:
                //Default entity node
                node = null;//new EntityNode(entity);
                break;
        }

        if (node !== null) {
            if (entity.isGhost()) {
                node.setVisible(false);
            }

            // Find attach
            var parentNode = null;
            // FIXME Temporay avoid scene and floor entities
            if (globally || (entity.parent !== null && (entity.parent.entityType === SceneConstants.EntityType.Scene))) {
                // Temporary hand le Floor and Scene as root node and add to grid
                parentNode = PlanManager.getInstance().scrollWindow.grid;
            }
            else {
                if (entity.parent !== null) {
                    //Retrieve parent node
                    var parentName = entity.parent.id;
                    // Find the parent node in the hierarchy
                    var _findNode = Utils.getChildByNameRecursivly(layer, parentName.toString());

                    // If found attach the current node to the parent
                    if (_findNode !== null) {
                        //Set as parent node
                        parentNode = _findNode;
                    }
                    else {
                        // TODO what happen when has a parent but can't find node ?
                        // console.log("Parent node don't exist");
                    }
                }
                else {
                    // TODO what happen if parent is null ? maybe a temporary or an orphan ?
                    parentNode = PlanManager.getInstance().scrollWindow.grid;
                }
            }

            // Attach to parent
            if (parentNode !== null) {
                parentNode.addChild(node, this.getLevel(entity));
                // Add child
                if (importChild) {
                    for (var i = 0; i < entity.children.length; i++) {
                        this.createNode(entity.children[i], importChild);
                    }
                }
            }
            else {
                // TODO what happen if no daddy found ? prevent from happenning ?
                // console.log("Parent node don't exist");
            }
        }

        // Return created node
        return node;
    };

    /**
    * Remove an entity from node arbo
    *
    * @param {String} entityId SavaneJS entity id
    **/
    deleteNode(entityId: number): boolean {
        //Retrieve node
        var name = entityId;
        // Try to find the node in the node hierarchy
        var node = Utils.getChildByNameRecursivly(PlanManager.getInstance().scrollWindow.grid, name);

        // Graphic node found
        if (node !== null) {
            // Remove node from parent
            node.removeFromParent(true);
            // Node found return true
            return true;
        }

        // Can't find node
        return false;
    };

    /**
    * Remove an entity from node and child
    *
    * @param {Entity} entityId SavaneJS entity id
    **/
    deleteNodeAndChild(entity: Entity) {
        if (!entity) {
            return;
        }

        for (var i = 0; i < entity.children.length; i++) {
            this.deleteNodeAndChild(entity.children[i]);
        }
        this.deleteNode(entity.id);
    };

    /**
    * Retrieve cocos node of designated entity
    * @param  {Number} id SavaneJS Entity id
    * @return {EntityNode} Cocos node
    **/
    getNodeById(id: number) {
        var node = Utils.getChildByNameRecursivly(PlanManager.getInstance().scrollWindow.grid, id);

        return node;
    };

    /**
    * Retrieve cocos node of designated entity
    * @param  {Entity} entity SavaneJS Entity
    * @return {EntityNode} Cocos node
    **/
    getNode(entity: Entity): EntityNode | null {
        //todo : dirty code : redraw arrangement on frontview ..create interface to call for updating the drawing of any sort of object(independant of frontview or normal view or whatever view we can create!)
        /*if (PlanManager.getInstance().frontViewLayer.isVisible())
        {
            FrontViewManager.updateDecoration(entity);
        }*/

        if (entity === undefined) {
            // console.log("error");
        }

        var node = Utils.getChildByNameRecursivly(PlanManager.getInstance().scrollWindow.grid, entity.id);

        return node;
    };

    /**
    *   Creates a joinery node depending on its type
    **/
    createJoinery(joinery: Joinery): JoineryNode {
        // Node to return
        var node = null;
        // Joinery type of the joinery to add
        var joineryType = joinery.joineryType;

        switch (joineryType) {
            case SceneConstants.JoineryType.door:
                node = new DoorNode(joinery as Door);
                break;

            case SceneConstants.JoineryType.frontDoor:
                node = new FrontDoorNode(joinery as Door);
                break;

            case SceneConstants.JoineryType.opening:
            case SceneConstants.JoineryType.garageDoor:
                node = new OpeningNode(joinery as Opening);
                break;

            case SceneConstants.JoineryType.cupboardDoor:
                node = new CupboardDoorNode(joinery as CupboardDoor);
                break;

            case SceneConstants.JoineryType.frenchWindow:
                node = new FrenchDoorNode(joinery as FrenchDoor);
                break;

            case SceneConstants.JoineryType.pictureWindow:
                node = new PictureWindowNode(joinery as PictureWindow);
                break;

            case SceneConstants.JoineryType.window:
                node = new WindowNode(joinery as Window);
                break;

            case SceneConstants.JoineryType.fixedWindow:
                node = new FixedWindowNode(joinery);
                break;

            case SceneConstants.JoineryType.velux:
                node = new VeluxNode(joinery as Velux);
                break;

            case SceneConstants.JoineryType.canopy:
                node = new CanopyNode(joinery as Canopy);
                break;

            case SceneConstants.JoineryType.niche:
                node = new NicheNode(joinery as Niche);
                break;
        }

        (node as JoineryNode).setJoineryType(joinery.joineryType);

        return node as JoineryNode;
    };
}


